import {action, observable, computed, makeObservable} from 'mobx';
import {apiService} from '../services/api.service';
import { utilsService } from '../services/utils.service';

class FeedbackStore {

  constructor() {
    makeObservable(this);
  }

  @action submitForm(form) {
    const inputs = form.querySelectorAll('input, select, textarea');
    this.showAlertBar = false;
    this.hasBeenSubmitted = false;
    for (var i = 0; i < inputs.length; ++i) {
        this.hasErrors[inputs[i].id] = inputs[i].value === '';
    }
    if (this.formIsValid) {
      let data = {};
      data.topic = this.feedbackObject["feedback_subject"];
      data.category = this.feedbackObject["feedback_category"];
      data.message = this.feedbackObject["feedback_message"];
      const success = () => {
        this.hasBeenSubmitted = true;
        this.clearFeedbackForm();
      }
      const failure = (res) => {
        utilsService.handleError(res);
        this.showExitModal = false;
      }
      apiService.submitCustomerFeedbackForm(data)
      .then(success, failure);
    } else {
      this.showAlertBar = true;
    }
  }

  @action changeValue(input, num) {
    this.feedbackObject[input.id] = input.value.substr(0, num);
  }

  @action validateInput(input) {
      this.hasErrors[input.id] = this.feedbackObject[input.id].length === 0;
  }

  @action toggleExitModal(newExitModalState = !this.showExitModal) {
      this.showExitModal = newExitModalState;
  }

  @action toggleHasBeenSubmitted() {
    this.hasBeenSubmitted = !this.hasBeenSubmitted;
  }

  @action toggleAlertBar() {
    this.showAlertBar = !this.showAlertBar;
  }

  @action clearFeedbackForm() {
    for (let key in this.feedbackObject) {
      this.feedbackObject[key] = '';
    }
    for (let key in this.hasErrors) {
      this.hasErrors[key] = false;
    }
    this.showAlertBar = false;
  }

  @computed get formIsValid() {
    for (let key in this.hasErrors) {
      if (this.hasErrors[key]) {
        return false;
      }
    }
    return true;
  }

  @computed get requiredFieldsEntered() {
    let requiredFieldsEntered = true;
    for (let key in this.feedbackObject) {
      if (!this.feedbackObject[key].length) requiredFieldsEntered = false;
    }
    return requiredFieldsEntered;
  }

  @computed get formHasEntries() {
    let formHasEntries = false;
    if (this.feedbackObject.feedback_subject.length || this.feedbackObject.feedback_message.length) formHasEntries = true;
    return formHasEntries;
  }

  @observable showExitModal = false;
  @observable showAlertBar = false;
  @observable hasBeenSubmitted = false;
  @observable feedbackObject = {
    feedback_subject: '',
    feedback_message: '',
    feedback_category: '',
  };
  @observable hasErrors = {
    feedback_subject: false,
    feedback_message: false,
    feedback_category: false,
  };
}

export const feedbackStore = new FeedbackStore();
